<div class="dropdown" [ngClass]="disabled && 'disabled'" [style.background-color]="backgroundColor">
  <div class="form-control dropdown-display-value" id="action{{id}}" (click)="open()" [style.min-width]="minWidth">
    <div class="name long-text">{{valueShow || name || title}}</div>
    <svg class="dropdown-arrow" xmlns="http://www.w3.org/2000/svg" width="13" height="8" viewBox="0 0 13 8" fill="none">
      <path
        d="M0.916472 0.523438H11.1575C11.3387 0.523476 11.5159 0.577259 11.6666 0.677986C11.8174 0.778713 11.9348 0.921863 12.0042 1.08934C12.0735 1.25681 12.0917 1.44109 12.0563 1.61888C12.021 1.79667 11.9337 1.95999 11.8056 2.08819L6.68505 7.20869C6.51315 7.38054 6.28004 7.47708 6.03697 7.47708C5.7939 7.47708 5.56079 7.38054 5.38889 7.20869L0.268388 2.08819C0.140229 1.95999 0.0529567 1.79667 0.0176031 1.61888C-0.0177505 1.44109 0.000402529 1.25681 0.0697667 1.08934C0.139131 0.921863 0.256592 0.778713 0.407301 0.677986C0.55801 0.577259 0.7352 0.523476 0.916472 0.523438Z"
        fill="#A1A7B4" />
    </svg>
  </div>
  <div id="{{id}}" class="dropdown-content" [ngClass]="openDropdownlist && 'show'">
    <input class="form-control" type="text" placeholder="Search.." [(ngModel)]="textSearch" (keyup)="filter()">
    <div class="list-item" *ngIf="groups.length === 0; else haveGroups">
      <a class="record" (click)="chooseAll()" *ngIf="!isNoAll && multiple">
        <span> Chọn tất cả</span>
      </a>
      <a class="record" (click)="chooseValue(defaultItem)" *ngIf="!isNoAll && !multiple">
        <span> Chọn tất cả</span>
      </a>
      <a class="record" *ngFor="let item of list" [ngClass]="{'hide': item.isHide, 'disabled': item.isDisabled }" (click)="chooseValue(item)">
        <div class="issuer__info">
          <img *ngIf="item.photos" [src]="item.photos[0]?.url" style="margin-right: 10px;">
          <span>{{item[field]}}</span>
        </div>
        <span *ngIf="item.isCheck"><i class="fa fa-check" aria-hidden="true"></i></span>
      </a>
    </div>
    <ng-template #haveGroups>
      <div class="list-item">
        <div class="d-flex flex-column" *ngFor="let group of groups">
          <span class="sub-title" (click)="chooseGroup(group)">{{group.option?.title}}</span>
          <div class="d-flex flex-column" style="margin-left: 15px;">
            <a class="record" *ngFor="let item of group.list" (click)="chooseValue(item)"
              [ngClass]="item.isHide && 'hide'">
              <img *ngIf="item.icon" [src]="item.icon" height="25" style="margin-right: 10px;">
              <span>{{item[field]}}</span>
              <span *ngIf="item.isCheck"><i class="fa fa-check" aria-hidden="true"></i></span>
            </a>
          </div>
        </div>
      </div>
    </ng-template>

  </div>
</div>
<span id="backdrop" class="backdrop"></span>